<template>
  <a-layout-content>
    <a-row>
      <a-col :xs="24" :sm="12">
        <a-card title="用户信息">
          <h4>账号：{{user.uname}}</h4>
          <div class="player" v-if='!user.is_admin'>
              <h4>用户名：{{user.name}}</h4>
              <h4>上一轮竞拍结果：{{user.is_win}}</h4>
              <h4>资金：{{user.money}}</h4>
              <span>资金变化：
              <font class="green-D" v-if="user.difference>0">+{{user.difference}}</font>
              <font class="red-D" v-else-if="user.difference<0">{{user.difference}}</font>
              <font class="silver" v-else>{{user.difference}}</font>
              </span>
          </div>
          <div v-else>
          <h4>用户名：{{user.name}}</h4>
          <a-button type="primary" size="large" @click="push('manage')">进入管理页面</a-button>
          </div>
          <p></p>
          <a-button type="primary" size="large" @click="logout()">注销</a-button>
        </a-card>
      </a-col>
      <a-col :xs="24" :sm="12">
        <a-card title="赛事信息">
          <h4>赛事名称：{{data.name}}</h4>
          <h4>当前轮数：{{data.lun}}</h4>
          <h4>赛事状态：{{end(data.control)}}</h4>
          <a-button type="primary" size="large" @click="push('rank/'+data.id)">资金排行</a-button>
        </a-card>
      </a-col>
    </a-row>
  </a-layout-content>
</template>
<script>
export default {
  data () {
    return {
      user: [],
      data: []
    }
  },
  created () {
    this.$http.get('https://auction-api.joyland.top/user').then(res => {
      if (!(res.data.code === 401)) {
        this.user = res.data
      } else {
        this.$message.success('请检查登录状态')
        this.$router.push('/login')
      }
    })
    this.$http
      .get('https://auction-api.joyland.top/system')
      .then(res => {
        this.data = res.data
      })
  },
  methods: {
    push (name) {
      this.$router.push('/' + name)
    },
    logout () {
      this.$http
        .get('https://auction-api.joyland.top/logout')
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success('注销成功')
            this.$router.push('/login')
          }
        })
    },
    end (type) {
      if (type === 1) return '正在进行'
      return '暂停提交'
    }
  }
}
</script>

<style>
  .green-D {color: #01CB99!important;;}
  .red-D {color: #D04957!important;;}
  .silver {color: #C0C0C0!important;;}
</style>
